export const sweetpass = {
  // ─── SIGNED OUT ──────────────────────────────────────────────────

  'sweetpass.sign-out.text':
    'Sign in to see all your challenges and get special rewards ',
  'sweetpass.sign-out.sign-in-or-join': 'Sign in or join',

  // ─── SIGNED IN ───────────────────────────────────────────────────

  'sweetpass.signed-in.header': 'sweetpass',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS JOIN ──────────────────────────────────────────────

  'sweetpass-join.title': 'Join sweetpass',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS UPGRADE ───────────────────────────────────────────

  'sweetpass-upgrade.title': 'Upgrade to sweetpass+',
  'sweetpass-upgrade.confirm-modal.button': 'Join sweetpass',
  'sweetpass-upgrade.confirm-modal':
    'By joining sweetpass you agree to {terms}. Opt out at any time by reaching out to our CX team at {email}.',
  'sweetpass-upgrade.confirm-modal.terms': 'sweetgreen’s terms and conditions',
  'sweetpass-upgrade.confirm-modal.terms-url':
    'https://www.sweetgreen.com/terms',
  'sweetpass-upgrade.confirm-modal.email': 'hello@sweetgreen.com',
  'sweetpass-upgrade.confirm-modal.email-url': 'mailto:hello@sweetgreen.com',
};
